import { FC, Suspense, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useApiCall } from '@/hooks';
import {
  amlbotAPI,
  ExternalPaymentRequest,
  ExternalPaymentResponse,
} from '@/api';
import { useStripe } from '@stripe/react-stripe-js';
import { AlertBox } from '@/components/AlertBox';
import { useTranslation } from 'react-i18next';

import styles from './PaymentRedirect.module.sass';

interface PaymentRedirectProps {}

const PaymentRedirect: FC<PaymentRedirectProps> = () => {
  const { t } = useTranslation();
  const stripe = useStripe();
  const { userData = '', invoiceData = '' } = useParams();
  const [stripeSessionId, setStripeSessionId] = useState<string | null>(null);
  const [getInvoiceData, loading, error] = useApiCall(async () => {
    const payload: ExternalPaymentRequest = {
      userData,
      invoiceData,
    };
    const response: ExternalPaymentResponse =
      await amlbotAPI.getExternalPayment(payload);

    if (response.success) {
      setStripeSessionId(() => response.data.data.stripeSessionId);
    }
  });

  useEffect(() => {
    getInvoiceData();
  }, []);

  if (stripeSessionId && stripe) {
    stripe.redirectToCheckout({
      sessionId: stripeSessionId,
    });
  }

  return (
    <>
      {loading && <Suspense />}
      {!!error && (
        <div className={styles.result}>
          <div className={styles.main}>
            <AlertBox type="danger">
              {{
                title: t('translation.error'),
                description: error,
              }}
            </AlertBox>
          </div>
        </div>
      )}
    </>
  );
};

export default PaymentRedirect;
